'use strict'

class SimulatorHighcharts {

    constructor(data) {
        this.data = data;
        this.height = [];
        this.chart_height = 310;
        this.maxv = 0;
        this.xAxis =[];
        this.chart1 =[];
        this.chart2 =[];
    }
    
    prepare(){
        let ln = this.data.length;

        for(let i = 0; i < ln; i++){
            let values = Object.values(this.data[i]);
            this.xAxis[i]=values[0];
            this.chart1[i]=values[3];
            this.chart2[i]=values[4];
        }
        return this;
    }

    getYearMin(){
        return 0;
    }
    
    getYearMax(){
        return this.data.length-1;
    }

    getData(from){
        return this.data[from];
    }

    getHeight(from){
        if(!this.data.years){
            return 0;
        }
        let i = this.data.years.indexOf(from);
        return this.height[i] ? this.height[i] : 0;
    }

    render(){
        Highcharts.chart('chart', {
            chart: {
                height:this.chart_height,
                type: 'area',
                marginBottom:35,
                marginLeft:6,
                marginRight:6,
                marginTop:0,
                backgroundColor: '#eff4f8',
            },
            exporting: {
                enabled: false
            },
            title: false,
            subtitle: false,
            legend:{
                enabled:false
            },
            xAxis: {
                categories: this.xAxis,
                labels: {
                    style: {
                      fontSize: '12px',
                    },
                    //x: 0,
                    //y: 37, 
                },
                lineColor: 'transparent',
                lineWidth: 0,
                
                //visible:false
            },
            yAxis: {
                visible:false,
                //max:this.maxv,
                //tickInterval:(this.maxv/10)
            },
            tooltip: {
                formatter: function () {
                    return '';
                }
            },
            plotOptions: {
              series: {
                marker: {
                  enabled: false,
                }
              },
              area: {
                    stacking: 'normal',
                    lineWidth: 0
                }
            },
            series: [
                {
                    name: 'AFAP',
                    data: this.chart2,
                    color:'#FF6200',
                    enableMouseTracking: false
                }, 
                //{
                //    name: 'BPS',
                //    data: this.chart1,
                //    color:'#fcae68',
                //    enableMouseTracking: false
                //}
            ]
        });
        return this;
    }
}

export default SimulatorHighcharts;